import { render, staticRenderFns } from "./TheLightbox.vue?vue&type=template&id=51479cc7&"
import script from "./TheLightbox.vue?vue&type=script&lang=js&"
export * from "./TheLightbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports